export default __webpack_public_path__ + "static/media/kitchen3-afterE-768w.a315b03f.avif";